/**
 * @generated SignedSource<<1db8105c40ba84364844af2ba5591ed1>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "DeletePlannedAbsencePayload",
            "kind": "LinkedField",
            "name": "deletePlannedAbsence",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfPlannedAbsence",
                    "kind": "LinkedField",
                    "name": "plannedAbsenceEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PlannedAbsence",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditPlannedAbsenceModalDeleteMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditPlannedAbsenceModalDeleteMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "bc981362d18a4fed2edfa0850dd18911",
            "id": null,
            "metadata": {},
            "name": "EditPlannedAbsenceModalDeleteMutation",
            "operationKind": "mutation",
            "text": "mutation EditPlannedAbsenceModalDeleteMutation(\n  $model: DeletePlannedAbsenceRequestInput!\n) {\n  deletePlannedAbsence(model: $model) {\n    plannedAbsenceEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "7aaa53876457d26338ff2f89fb7a08be";
export default node;
